var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.allowed ? _c('div', {
    staticClass: "my-5 md:my-15 2xl:my-20"
  }, [_c('h3', {
    staticClass: "mb-15 2xl:mb-20 w-full"
  }, [_vm._v("\n    Dépôt de documents\n  ")]), _vm._v(" "), _vm.path.length === 0 && (_vm.folders.length > 0 || _vm.files.length > 0) ? _c('root-folder', {
    attrs: {
      "folders": _vm.folders,
      "files": _vm.files,
      "color-by-type": _vm.colorByType
    },
    on: {
      "openFolder": function (folder) {
        _vm.addFolderToPath(folder);
      },
      "displayAllFiles": function ($event) {
        return _vm.displayAllFiles();
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.path[0] === 'allFiles' ? _c('recent-files', {
    attrs: {
      "files": _vm.files,
      "folders": _vm.folders,
      "color-by-type": _vm.colorByType
    },
    on: {
      "goto": function (index) {
        _vm.goToPath(index);
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.path.length > 0 && _vm.path[0] !== 'allFiles' ? _c('current-folder', {
    attrs: {
      "path": _vm.path,
      "files": _vm.files,
      "folders": _vm.folders
    },
    on: {
      "openFolder": function (folder) {
        _vm.addFolderToPath(folder);
      },
      "goto": function (index) {
        _vm.goToPath(index);
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.path.length === 0 && _vm.folders.length === 0 && _vm.files.length === 0 ? _c('no-file-found') : _vm._e()], 1) : _c('page-not-allowed');

}
var staticRenderFns = []

export { render, staticRenderFns }